import React  from "react";
import "./AuttoletturaPage.scss";
import CaseGenerator from "../../CaseGenerator/CaseGenerator";
import {PageForms} from "../../../helpers/enums";

const AutoletturaPage = () => {
  /* eslint-disable */


  return (
    <div className="AutoletturaPage" data-testid="AutoletturaPage">
      <CaseGenerator type={PageForms.SelfReadingOperator}/>
    </div>
  );
};

AutoletturaPage.propTypes = {};

export default AutoletturaPage;
